import { useTracking } from '@change-corgi/core-react/tracking';

import { useLocalPagePaginatedPetitionUpdatesData } from 'src/app/pages/local/pageContext';
import type { LocalPetitionUpdatesItem } from 'src/app/pages/local/pageContext';

type Result = ModelHookResult<
	{
		displayed: boolean;
		petitionUpdates: readonly LocalPetitionUpdatesItem[];
		hasNextPage: boolean;
		nextPageLoading: boolean;
	},
	{
		loadMore: () => void;
	}
>;

export function usePetitionUpdatesSection(): Result {
	const track = useTracking();

	const {
		data: { hasNextPage, items, nextPageLoading, totalCount },
		actions: { loadMore },
	} = useLocalPagePaginatedPetitionUpdatesData();

	return {
		data: {
			petitionUpdates: items,
			displayed: totalCount > 0,
			hasNextPage,
			nextPageLoading,
		},
		actions: {
			loadMore: () => {
				void track('local_page_load_more_petition_updates_click');
				loadMore();
			},
		},
	};
}
